import React from "react"
import ListItem from "./ListItem"
import Component from "../"
import {inject, observer} from "mobx-react";

const List = (props) => {
	
	return (
		<div className="row">
			<h3>{props.title}</h3>
			{
				props.Data[props.class].length === 0 && <Component.Alert type="info" text="Lista pusta"/>
			}
			<div className="card">
				{props.Data[props.class].map((item, key) => <ListItem item={item} class={props.class} key={key}/>)}
			</div>
		</div>
	);
}

export default inject('Data')(observer(List))
